import React from 'react'

import { Contract, User, UserMetadata } from '../../../common/validations'
import { useAPIGetContractSuspense } from '../../api/apiHooks/useAPIGetContract'
import { useAPIGetUserProfileSuspense } from '../../api/apiHooks/useAPIGetUserProfile'
import { useAPIGetUserMetadataSuspense } from '../../api/apiHooks/useAPIGetUserMetadata'
import { useCurrentContract } from '../../hooks/useCurrentContract/useCurrentContract'

interface Data {
  contract: Contract
  user: User
  userMetadata: UserMetadata
}

export const FeedbackDataLoader = ({
  children,
}: {
  children: (data: Data) => React.ReactNode
}) => {
  const { currentContractId } = useCurrentContract()
  const { data: contract } = useAPIGetContractSuspense(currentContractId)
  const { data: user } = useAPIGetUserProfileSuspense()
  const { data: userMetadata } = useAPIGetUserMetadataSuspense()

  return children({
    contract,
    user,
    userMetadata,
  })
}
